/* ===== كراجي بارت فاي =====
   يحفظ حتى 3 سيارات في متصفح العميل (localStorage) مع رابط نتائج EasySearch لكل سيارة.
   طريقة الالتقاط: نقرأ اختيارات القوائم داخل ويدجت EasySearch لحظة البحث،
   وبعد انتقال الصفحة لنتائج البحث نحفظ الرابط. لا نلمس بيانات التطبيق نفسه. */
(function () {
  'use strict';

  var KEY = 'pf-garage-v1';
  var PENDING = 'pf-garage-pending';
  var MAX = 3;
  var PENDING_TTL = 20 * 1000; // النتائج تفتح خلال ثوانٍ؛ أطول من كذا يعني العميل راح لصفحة ثانية
  var WIDGET = '.easysearch-embed-widget-main, [class*="easysearch"]';

  var root = document.querySelector('[data-garage]');
  var ds = root ? root.dataset : {};

  /* ---------- تخزين آمن ---------- */
  function store(kind) {
    try { var s = window[kind]; s.setItem('__pf', '1'); s.removeItem('__pf'); return s; }
    catch (e) { return null; }
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');

  function isLocalPath(u) {
    return typeof u === 'string' && u.charAt(0) === '/' && u.charAt(1) !== '/' && u.length < 1500;
  }
  function valid(c) {
    return c && typeof c.name === 'string' && c.name.length > 0 && c.name.length < 120 && isLocalPath(c.url);
  }
  /* ---------- قراءة السيارة من وسم EasySearch ----------
     EasySearch يفلتر بوسم مثل: كيا-أوبتيما-2-4-2011-2013-esi5317775
     نحوّله إلى: { base: "كيا أوبتيما 2.4", years: "2011–2013" } */
  var YEAR = /^(19|20)\d\d$/;
  function parseFitment(raw) {
    var s = String(raw || '');
    if (!/esi\d+/i.test(s)) return null;
    s = s.replace(/[-_\s]*esi\d+[-_\s]*/ig, ' ');
    var tk = s.split(/[-_\s]+/).filter(Boolean), out = [], years = [];
    for (var i = 0; i < tk.length; i++) {
      var t = tk[i], n = tk[i + 1] || '';
      if (YEAR.test(t)) years.push(t);
      else if (/^\d$/.test(t) && /^\d$/.test(n)) { out.push(t + '.' + n); i++; }   // 2-4 → 2.4
      else out.push(t);
    }
    if (!out.length) return null;
    years.sort();
    var yr = !years.length ? '' : years[0] === years[years.length - 1] ? years[0] : years[0] + '–' + years[years.length - 1];
    return { base: out.join(' '), years: yr };
  }
  function fitmentFromUrl(url) {
    try {
      var u = new URL(url, location.origin), found = null;
      u.searchParams.forEach(function (v, k) { if (!found && /^filter\./.test(k)) found = parseFitment(v); });
      if (!found) found = parseFitment(decodeURIComponent(u.pathname.split('/').pop() || ''));
      return found;
    } catch (e) { return null; }
  }
  function carName(labels, url) {
    var fit = fitmentFromUrl(url);
    var year = '';
    for (var i = 0; i < labels.length; i++) if (YEAR.test(labels[i])) year = labels[i];
    if (fit && year && fit.years) {                         // سنة العميل لازم تكون داخل مدى الوسم
      var r = fit.years.split('–');
      if (year < r[0] || year > (r[1] || r[0])) year = '';
    }
    if (fit) return fit.base + ((year || fit.years) ? ' (' + (year || fit.years) + ')' : '');
    return labels.join(' ');
  }

  function load() {
    if (!LS) return [];
    try {
      var a = JSON.parse(LS.getItem(KEY) || '[]');
      if (!Array.isArray(a)) return [];
      a = a.filter(valid).slice(0, MAX);
      // إصلاح سيارات انحفظت باسم ناقص (مثل "2013" فقط) من النسخة السابقة
      var fixed = false;
      a.forEach(function (c) {
        if (/^[\d\s–-]+$/.test(c.name)) {
          var f = fitmentFromUrl(c.url);
          if (f) { c.name = f.base + ' (' + c.name.trim() + ')'; fixed = true; }
        }
      });
      if (fixed) try { LS.setItem(KEY, JSON.stringify(a)); } catch (e) {}
      return a;
    } catch (e) { return []; }
  }
  function save(list) {
    if (!LS) return;
    try { LS.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function getPending() {
    if (!SS) return null;
    try {
      var p = JSON.parse(SS.getItem(PENDING) || 'null');
      if (!p || !Array.isArray(p.labels) || Date.now() - p.t > PENDING_TTL) return null;
      return p;
    } catch (e) { return null; }
  }
  function setPending(p) { if (SS) try { SS.setItem(PENDING, JSON.stringify(p)); } catch (e) {} }
  function clearPending() { if (SS) try { SS.removeItem(PENDING); } catch (e) {} }

  function here() { return location.pathname + location.search; }

  /* ---------- قراءة اختيار العميل من ويدجت EasySearch ---------- */
  var PLACEHOLDER = /اختر|اختار|حدد|select|choose|^[-—–\s]*$/i;
  function readSelection(widget) {
    var out = [];
    var sels = widget.querySelectorAll('select');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i];
      if (s.selectedIndex < 0 || s.value === '') continue;
      var txt = (s.options[s.selectedIndex].textContent || '').replace(/\s+/g, ' ').trim();
      if (txt && !PLACEHOLDER.test(txt)) out.push(txt);
    }
    return out;
  }
  function selectionComplete(widget) {
    var sels = widget.querySelectorAll('select');
    if (!sels.length) return false;
    for (var i = 0; i < sels.length; i++) {
      if (sels[i].disabled) continue;
      var o = sels[i].options[sels[i].selectedIndex];
      if (!o || sels[i].value === '' || PLACEHOLDER.test(o.textContent || '')) return false;
    }
    return true;
  }

  /* صفحات مستحيل تكون نتائج بحث — ما نحفظ عليها */
  function looksLikeResults(path) {
    var p = path.split('?')[0];
    if (p === '/' || p === '') return path.indexOf('?') > -1;
    return !/^\/(products|cart|account|checkout|blogs|policies)\b/i.test(p.replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/'));
  }

  /* ---------- الحفظ ---------- */
  var lastLabels = [];

  function markPending(labels) {
    if (!labels || !labels.length) return;
    setPending({ labels: labels.slice(0, 5), from: here(), t: Date.now() });
    watchUrl();
  }

  function finalize() {
    var p = getPending();
    if (!p) return false;
    var now = here();
    if (now === p.from || !looksLikeResults(now)) return false;
    clearPending();

    var name = carName(p.labels, now).slice(0, 110);
    var list = load();
    var existing = -1;
    for (var i = 0; i < list.length; i++) if (list[i].name === name || list[i].url === now) existing = i;
    var isNew = existing === -1;
    if (!isNew) list.splice(existing, 1);
    list.unshift({ name: name, url: now, t: Date.now() });
    save(list);
    render(isNew);
    if (isNew && window.pfToast) window.pfToast((ds.i18nSaved || 'حفظنا {car} في كراجي').replace('{car}', name));
    return true;
  }

  /* لو EasySearch يفلتر بدون إعادة تحميل (pushState) نراقب تغيّر الرابط لثوانٍ */
  var watching = null;
  function watchUrl() {
    if (watching) clearInterval(watching);
    var start = here(), n = 0;
    watching = setInterval(function () {
      n++;
      if (here() !== start && finalize()) { clearInterval(watching); watching = null; }
      else if (n > 20) { clearInterval(watching); watching = null; }
    }, 400);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'SELECT' || !t.closest) return;
    var w = t.closest(WIDGET);
    if (!w) return;
    lastLabels = readSelection(w);
    // بعض الإعدادات تبحث تلقائيًا عند آخر قائمة
    if (selectionComplete(w)) markPending(lastLabels);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var w = t.closest(WIDGET);
    if (!w || t.closest('select')) return;
    if (!t.closest('button, input[type="submit"], a, [role="button"], [class*="btn"], [class*="button"]')) return;
    var labels = readSelection(w);
    markPending(labels.length ? labels : lastLabels);
  }, true);

  document.addEventListener('submit', function (e) {
    var w = e.target && e.target.closest && e.target.closest(WIDGET);
    if (!w) return;
    var labels = readSelection(w);
    markPending(labels.length ? labels : lastLabels);
  }, true);

  /* ---------- الواجهة ---------- */
  if (!root) { finalize(); return; }

  var btn = root.querySelector('[data-garage-toggle]');
  var panel = root.querySelector('[data-garage-panel]');
  var listEl = root.querySelector('[data-garage-list]');
  var emptyEl = root.querySelector('[data-garage-empty]');
  var moreEl = root.querySelector('[data-garage-more]');
  var labelEl = root.querySelector('[data-garage-label]');
  var dotEl = root.querySelector('[data-garage-dot]');
  var titleTx = ds.i18nTitle || 'كراجي';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function render(animate) {
    var list = load();
    var has = list.length > 0;

    labelEl.textContent = has ? list[0].name : titleTx;
    root.classList.toggle('has-car', has);
    dotEl.hidden = !has;
    btn.setAttribute('aria-label', has ? titleTx + ': ' + list[0].name : titleTx);

    listEl.textContent = '';
    list.forEach(function (car, i) {
      var li = el('li', 'pf-garage__item' + (i === 0 ? ' is-current' : ''));
      var info = el('div', 'pf-garage__info');
      info.appendChild(el('span', 'pf-garage__name', car.name));
      if (i === 0) info.appendChild(el('span', 'pf-garage__tag', ds.i18nCurrent || 'الحالية'));
      var go = el('a', 'pf-garage__go', ds.i18nShop || 'تسوّق قطعها');
      go.href = car.url;
      go.addEventListener('click', function () {
        var l = load(); var idx = -1;
        for (var k = 0; k < l.length; k++) if (l[k].name === car.name) idx = k;
        if (idx > 0) { var c = l.splice(idx, 1)[0]; l.unshift(c); save(l); }
      });
      var rm = el('button', 'pf-garage__rm');
      rm.type = 'button';
      rm.setAttribute('aria-label', (ds.i18nRemove || 'احذف') + ' ' + car.name);
      rm.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      rm.addEventListener('click', function () {
        save(load().filter(function (c) { return c.name !== car.name; }));
        render(false);
        var next = listEl.querySelector('.pf-garage__rm') || panel.querySelector('[data-garage-add]:not([hidden])');
        if (next) next.focus();
      });
      li.appendChild(info); li.appendChild(go); li.appendChild(rm);
      listEl.appendChild(li);
    });

    listEl.hidden = !has;
    emptyEl.hidden = has;
    moreEl.hidden = !has || list.length >= MAX;

    if (animate) {
      root.classList.remove('is-parked');
      void root.offsetWidth;
      root.classList.add('is-parked');
    }
    renderFinderStrip(list);
  }

  /* شريط "سيارتك" فوق بطاقة البحث في الهيرو */
  function renderFinderStrip(list) {
    var strip = document.querySelector('[data-garage-last]');
    if (!strip) return;
    if (!list.length) { strip.hidden = true; return; }
    strip.querySelector('[data-garage-last-name]').textContent = list[0].name;
    strip.querySelector('[data-garage-last-link]').href = list[0].url;
    strip.hidden = false;
  }

  /* فتح وإغلاق */
  /* الهيدر فيه backdrop-filter، فأي عنصر fixed داخله يتقيّد بحدوده.
     على الجوال ننقل اللوحة للـ body عشان تطلع كورقة سفلية فعلًا. */
  var mq = window.matchMedia ? matchMedia('(max-width: 900px)') : { matches: false };
  function open() {
    if (mq.matches && panel.parentNode !== document.body) document.body.appendChild(panel);
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    root.classList.add('is-open');
    var f = panel.querySelector('a, button:not([data-garage-close])');
    if (f) f.focus();
    document.addEventListener('click', outside, true);
    document.addEventListener('keydown', onKey);
  }
  function close(returnFocus) {
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-open');
    document.removeEventListener('click', outside, true);
    document.removeEventListener('keydown', onKey);
    if (panel.parentNode !== root) root.appendChild(panel);
    if (returnFocus) btn.focus();
  }
  function outside(e) { if (!root.contains(e.target) && !panel.contains(e.target)) close(false); }
  function onKey(e) { if (e.key === 'Escape') close(true); }

  btn.addEventListener('click', function () { panel.hidden ? open() : close(true); });
  root.querySelector('[data-garage-close]').addEventListener('click', function () { close(true); });

  /* "أضف سيارتك": لو بطاقة البحث في نفس الصفحة ننزل لها مباشرة */
  function goFinder(e) {
    var finder = document.getElementById('pf-finder');
    if (!finder) return;
    if (e) e.preventDefault();
    close(false);
    focusFinder(finder);
  }
  function focusFinder(finder) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    finder.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    finder.classList.remove('is-flash');
    void finder.offsetWidth;
    finder.classList.add('is-flash');
    setTimeout(function () {
      var s = finder.querySelector('select');
      if (s) try { s.focus({ preventScroll: true }); } catch (x) { s.focus(); }
    }, reduce ? 0 : 450);
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-garage-add]'), function (a) {
    a.addEventListener('click', goFinder);
  });

  /* تجميل وسوم EasySearch في الفلاتر: "كيا-أوبتيما-2-4-2011-2013-esi…" → "كيا أوبتيما 2.4 (2011–2013)" */
  Array.prototype.forEach.call(document.querySelectorAll('[data-fitment-label]'), function (n) {
    var f = parseFitment(n.getAttribute('data-fitment-label'));
    if (f) n.textContent = f.base + (f.years ? ' (' + f.years + ')' : '');
  });

  /* تزامن بين التبويبات */
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(false); });

  render(false);
  finalize();

  if (location.hash === '#pf-finder') {
    var f = document.getElementById('pf-finder');
    if (f) setTimeout(function () { focusFinder(f); }, 300);
  }
})();
